module.exports = __webpack_public_path__ + "static/media/crypto.a487914b.svg";